/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { ZodError } from 'zod';

export const formatError = (err: any) => {
    if (typeof err === 'string') {
        return err;
    } else if (err instanceof ZodError) {
        return err.message;
    } else if ('steps' in err && Array.isArray(err.steps) && err.steps.length > 0) {
        try {
            return err.steps[0].name.message;
        } catch (e) {}
    } else if ('info' in err) {
        if (err.info?.code && err.info.code === 'TOO_MANY_ATTEMPTS') {
            return 'You ran out of quota, please contact the Heal.dev team to request quota.';
        }
        const message = err.info?.message || err.info?.error;
        return `${message || ''} ${err?.info.code}`;
    } else if (err instanceof Error) {
        return err.message; // works, `e` narrowed to Error
    } else if (err === undefined) {
        return undefined;
    }
    try {
        return JSON.stringify(err);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(err);
    }
};

const DisplayError = (props: { error: any; className?: string }) => {
    const className = props?.className ?? 'text-xs text-red-500';

    return <div className={className}>{formatError(props.error)}</div>;
};

export default DisplayError;
